import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { SponsorBanner } from '@synergy/models';

export class SponsorBannerListApi {
    constructor(protected baseUrl: string) {}

    public getSponsorBanners(searchParams: URLSearchParams): Promise<ApiResult<PaginatedResponse<SponsorBanner>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/sponsor-banners`, { params: searchParams }),
            response => response.data
        );
    }
}
